<h1 mat-dialog-title class="p-2 text-center">Ajout d'une pause</h1>
<div mat-dialog-content class="p-3">
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Heure Début</mat-label>
            <input matInput [ngxTimepicker]="timepicker1" [value]="formatTime(Debut)" [format]="24" readonly>
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetDebut($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Heure Fin</mat-label>
            <input matInput [ngxTimepicker]="timepicker2" [value]="formatTime(Fin)" [format]="24" readonly>
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetFin($event)"></ngx-material-timepicker>
        </mat-form-field>
    </div>
    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>